import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { Membership } from 'src/features/userManagement/types';

const RESOURCE = '/parkings/:parkingId/invitations/:invitationId/accept/';

interface DTO {
    parkingId: string;
    invitationId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, invitationId, ...data }: DTO): Promise<Membership> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, invitationId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as ACCEPT_INVITATION_RESOURCE, useMutationHook as useAcceptInvitation };
export type { DTO as AcceptInvitationDTO };
